var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 17,
  viewBox: "0 0 14 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 14.3546C13 14.6439 12.885 14.9214 12.6805 15.126C12.4759 15.3305 12.1984 15.4455 11.9091 15.4455H2.09091C1.80158 15.4455 1.52411 15.3305 1.31952 15.126C1.11494 14.9214 1 14.6439 1 14.3546V2.35458C1 2.06525 1.11494 1.78778 1.31952 1.58319C1.52411 1.37861 1.80158 1.26367 2.09091 1.26367H9.18182L13 5.08185V14.3546Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.63647 1.26367V5.62731H13.0001",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgFile;